/* eslint-disable semi,semi-style */
export const loadCss = (url) => {
  let head = document.querySelector('head')
  let link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  link.id = `microfe_${Date.now()}_${Math.random()}`
  head.appendChild(link)
}

export const loadScript = (url) => {
  let head = document.querySelector('head')
  let script = document.createElement('script')
  script.src = url
  script.type = 'text/javascript'
  script.defer = true
  script.async = false
  script.id = `microfe_${Date.now()}_${Math.random()}`
  head.appendChild(script)
}

export const removeRes = () => {
  const head = document.querySelector('head')
  const linkList = document.querySelectorAll('link[id^="microfe_"]')
  const scriptList = document.querySelectorAll('script[id^="microfe_"]')
  ;[...linkList, ...scriptList].forEach((it) => {
    head.removeChild(it)
  })
}